import { render, staticRenderFns } from "./CmdrSettings.vue?vue&type=template&id=92b2fee2&"
import script from "./CmdrSettings.vue?vue&type=script&lang=js&"
export * from "./CmdrSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports